import {
	set,
	// throwOnEmptyPath,
	// unset,
	// withPath
} from '@mapsight/core/lib/base/actions';
// import {batchActions} from 'redux-batched-actions';
import {STADE} from './controller';

export function setLanguageOpen(navOpen) {
	return set([STADE, 'language', 'open'], navOpen);
}

export function setNavigationOpen(navOpen) {
	return set([STADE, 'navigation', 'open'], navOpen);
}

export const AUDIOPLAYER_START = 'STADE_AUDIOPLAYER_START';

export function audioplayerStart() {
	return {type: AUDIOPLAYER_START};
}

export const AUDIOPLAYER_PAUSE = 'STADE_AUDIOPLAYER_PAUSE';

export function audioplayerPause() {
	return {type: AUDIOPLAYER_PAUSE};
}


export const SET_HEART = 'STADE_SET_HEART';

export function setHeart(appUri, poiId, value) {
	return {type: SET_HEART, appUri, poiId, value};
}

/** for internal use of StadeController only */
export const SET_HEARTS_FROM_BROWSER = 'STADE_SET_HEARTS_FROM_BROWSER';

export function setHeartsFromBrowser(appUri, value) {
	return {type: SET_HEARTS_FROM_BROWSER, appUri, value};
}
